import Typography from '@mui/material/Typography';

/**
 * One line beside a "Download report / Export" button saying what happened.
 * The download itself lands in the browser's downloads tray, which is easy
 * to miss — this is what tells the user a file was actually made.
 */
export function PreparedDownloadNote({
  error,
  done,
}: {
  error: string | null;
  done: string | null;
}) {
  if (error) {
    return (
      <Typography variant="caption" color="error" role="alert">
        {error.charAt(0).toUpperCase() + error.slice(1)}
      </Typography>
    );
  }
  if (done) {
    return (
      <Typography variant="caption" color="text.secondary" role="status">
        Saved {done} — check your Downloads
      </Typography>
    );
  }
  return null;
}
